
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { Messages } from '~src/codegen/Localize';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { LocalizationLoader } from '~src/commonInfra/services/LocalizationLoader';
import { imgLangPath, imgUrl } from '~src/commonInfra/utils/ImgUrl';
import { ISiteAdminDataConnectSettings } from '~src/settings/types/ISiteAdminDataConnectSettings';
import { cssClass } from '~src/style';

import { useSelector } from '../general-settings/utils';

export type SiteDataConnectSettingsForSiteAdminProps = {
  settings: {
    siteId?: string;
    siteAdminDataConnectSettings?: ISiteAdminDataConnectSettings;
  };
};

export type DataConnectSiteSettingsDefaultProps = SiteDataConnectSettingsForSiteAdminProps



export function DataConnectSiteSettingsDefault(props: DataConnectSiteSettingsDefaultProps) {

  const language = useSelector(SessionUserSelectors.language);
  const locale = LocalizationLoader.selectLocaleOrDefault(language);

  let helpTextList=[{key:Messages.dataConnectSiteSettingsDefaultInformationalListItem1Key(), des:Messages.dataConnectSiteSettingsDefaultInformationalListItem1Des()},
    {key:Messages.dataConnectSiteSettingsDefaultInformationalListItem2Key(), des:Messages.dataConnectSiteSettingsDefaultInformationalListItem2Des()},
    {key:Messages.dataConnectSiteSettingsDefaultInformationalListItem3Key(), des:Messages.dataConnectSiteSettingsDefaultInformationalListItem3Des()},
  ];
  let helpText: Array<JSX.Element>=[];
     helpTextList.forEach(
        (element)=>{ helpText.push(<li key={element.key}><span style={{fontWeight:500}}>{element.key}</span>{element.des}</li>); }
  );

  const onLearnMore = () => {
      window.open(HelpService.getHelpUrlByCategory('DataConnecct-Default-page-cloud'), '_blank');
  };

  return (
        <div className={wrapper}>
          <div className={imageContent}>
            <img width={600} alt={Messages.dataConnectSiteSettingsDefaultInformationContentHeader()} src={imgLangPath('dataconnect_default.png', locale)}/>
          </div>
          <div className={textContent}>
            <div className={header}>{Messages.dataConnectSiteSettingsDefaultInformationContentHeader()}</div>
            <div className={description}>{Messages.dataConnectSiteSettingsDefaultInformationTextHeading()}</div>
            <div>{Messages.dataConnectSiteSettingsDefaultInformationalListLabel()}</div>
            <ul className={getListWrapper()}>
                {helpText}
            </ul>
            <div className={buttonWrapper}>
              <ButtonWidget onClick={onLearnMore} buttonType={ButtonType.Primary}>{Messages.learnMore()}</ButtonWidget>
            </div>
          </div>
        </div>
  );
}

const cssPrefix = 'default';
const getListWrapper = () => cssClass(cssPrefix, 'listWrapper', {
  listStyleImage: imgUrl('check_12px-xsmall.svg'),
  paddingInlineStart: 20,
  $nest: {
    'li': {
      padding: '8px 4px',
    }
  }
});

const header = cssClass(cssPrefix, 'header', {
  fontSize: 16,
  paddingBottom: 16,
});
const description = cssClass(cssPrefix, 'description', {
  paddingBottom: 16,
});
const wrapper = cssClass(cssPrefix, 'wrapper', {
  display: 'flex',
  padding: 40,
  gap: 40,
});
const textContent = cssClass(cssPrefix, 'textContent', {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 530,
});
const imageContent = cssClass(cssPrefix, 'imageContent', {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 600,
});
const buttonWrapper = cssClass(cssPrefix, 'buttonWrapper', {
  display: 'flex',
  gap: 8
});